import Paper from '~components/dumbs/Paper';
import { Props } from './types';
import * as Styled from './styled';

function ScrollingList({ title, items, onClick, maxHeight }: Props) {
  return (
    <Paper elevation={4} outlined>
      {title && <Styled.Title>{title}</Styled.Title>}
      <Styled.List borderRadiusOnFirstItem={!!!title} $maxHeight={maxHeight}>
        {items.map((item) => (
          <Styled.ListItem
            key={item.id}
            onClick={() => {
              onClick?.(item);
              item?.onClick?.();
            }}
            clickable={!!onClick || !!item?.onClick}
          >
            {typeof item.value === 'string' ||
            typeof item.value === 'number' ? (
              <Styled.Text>{item.value}</Styled.Text>
            ) : (
              item.value
            )}
          </Styled.ListItem>
        ))}
      </Styled.List>
    </Paper>
  );
}

export default ScrollingList;
